// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
// import { bxAnaalyse } from '@/core/icons'

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/dishes/index',
    children: [
      //  画餐管理
      {
        path: '/dishes',
        redirect: '/dishes/index',
        component: PageView,
        meta: { title: '画餐管理', icon: 'pie-chart', permission: ['/admin/dishes/index'] },
        children: [
          {
            path: '/dishes/index',
            name: 'Index',
            component: () => import('@/views/dishes/Index'),
            meta: { title: '画餐列表', keepAlive: true, permission: ['/admin/dishes/index'] }
          }
        ]
      },
      // 建议投诉
      {
        path: '/suggestion',
        redirect: '/suggestion/index',
        component: PageView,
        meta: { title: '投诉建议', icon: 'calendar', permission: ['/admin/suggest/index'] },
        children: [
          {
            path: '/suggestion/index',
            name: 'suggestion',
            component: () => import('@/views/suggestion/Index'),
            meta: { title: '投诉建议列表', keepAlive: true, permission: ['/admin/suggest/index'] }
          }
        ]
      },
      // 微语录
      {
        path: '/quotations',
        redirect: '/quotations/index',
        component: PageView,
        meta: { title: '微语录', icon: 'bars', permission: ['/admin/motto/index'] },
        children: [
          {
            path: '/quotations/index',
            name: 'quotations',
            component: () => import('@/views/quotations/Index'),
            meta: { title: '微语录', keepAlive: true, permission: ['/admin/motto/index'] }
          }
        ]
      },
      // 书签管理
      {
        path: '/bookmark',
        redirect: '/bookmark/index',
        component: PageView,
        meta: { title: '书签管理', icon: 'tags', permission: ['/admin/bookmark/index'] },
        children: [
          {
            path: '/bookmark/index',
            name: 'bookmark',
            component: () => import('@/views/bookmark/Index'),
            meta: { title: '书签管理', keepAlive: true, permission: ['/admin/bookmark/index'] }
          }
        ]
      },
      // 工具配置
      {
        path: '/setUp',
        redirect: '/setUp/index',
        component: PageView,
        meta: { title: '工具配置', icon: 'setting', permission: ['/admin/tool/index'] },
        children: [
          {
            path: '/setUp/index',
            name: 'setUp',
            component: () => import('@/views/setUp/Index'),
            meta: { title: '工具配置', keepAlive: true, permission: ['/admin/tool/index'] }
          }
        ]
      },
      // 文章发布
      {
        path: '/article',
        redirect: '/article/article-management',
        component: PageView,
        meta: {
          title: '文章发布',
          icon: 'file-text',
          permission: ['/admin/articlePost/index', '/admin/articleCategory/index']
        },
        children: [
          {
            path: '/article/article-management',
            name: 'ArticleManagement',
            component: () => import('@/views/article/ArticleManagement'),
            meta: { title: '文章管理', keepAlive: true, permission: ['/admin/articlePost/index'] }
          },
          {
            path: '/article/classified-management',
            name: 'ClassifiedManagement',
            component: () => import('@/views/article/ClassifiedManagement'),
            meta: { title: '分类管理', keepAlive: true, permission: ['/admin/articleCategory/index'] }
          }
        ]
      },
      // 发布公告
      {
        path: '/announcement',
        redirect: '/announcement/article-management',
        component: PageView,
        meta: { title: '发布公告', icon: 'notification', permission: ['/admin/notice/index'] },
        children: [
          {
            path: '/announcement/release',
            name: 'AnnouncementRelease',
            component: () => import('@/views/announcement/Release'),
            meta: { title: '发布公告', keepAlive: true, permission: ['/admin/notice/index'] }
          }
        ]
      },
      {
        path: '/privileges',
        component: PageView,
        redirect: '/privileges/management',
        meta: {
          title: '用户管理',
          icon: 'user',
          permission: ['/admin/adminRole/index', '/admin/adminAccess/index', '/admin/frontUser/index']
        },
        children: [
          {
            path: '/privileges/management-group',
            name: 'ManagementGroup',
            component: () => import('@/views/privileges/management/ManagementGroup'),
            meta: { title: '角色管理', keepAlive: true, permission: ['/admin/adminRole/index'] }
          },
          {
            path: '/privileges/usergroup/user-list',
            name: 'UserList',
            component: () => import('@/views/privileges/usergroup/user-list'),
            meta: { title: '用户列表', keepAlive: true, permission: ['/admin/frontUser/index'] }
          },
          {
            path: '/privileges/menulist',
            name: 'Menulist',
            component: () => import('@/views/privileges/management/MenuList'),
            meta: { title: '菜单列表', keepAlive: true, permission: ['/admin/adminAccess/index'] }
          }
        ]
      },
      //  弹幕设置
      {
        path: '/bulletchat',
        redirect: '/bulletchat/index',
        component: PageView,
        meta: {
          title: '弹幕设置',
          icon: 'message',
          keepAlive: true,
          permission: ['/admin/bulletChat/index', '/admin/bulletChatConfig/update']
        },
        children: [
          {
            path: '/bulletchat/index',
            name: 'bulletchatIndex',
            component: () => import('@/views/bulletchat/index'),
            meta: { title: '弹幕设置', keepAlive: true, permission: ['/admin/bulletChatConfig/update'] }
          },
          {
            path: '/bulletchat/list',
            name: 'bulletchatList',
            component: () => import('@/views/bulletchat/list'),
            meta: { title: '弹幕列表', keepAlive: true, permission: ['/admin/bulletChat/index'] }
          }
        ]
      },
      // todolist
      {
        path: '/todolist',
        redirect: '/todolist/index',
        component: PageView,
        meta: { title: '代办事项', icon: 'snippets', keepAlive: true, permission: ['/admin/todo/index'] },
        children: [
          {
            path: '/todolist/index',
            name: 'todolistIndex',
            component: () => import('@/views/todolist/index'),
            meta: { title: '代办事项', keepAlive: true, permission: ['/admin/todo/index'] }
          }
        ]
      }
      // 用户管理
      // {
      //   path: '/privileges',
      //   component: PageView,
      //   redirect: '/privileges/management',
      //   meta: { title: '用户管理', icon: 'user', permission: [ '/admin/adminRole/index', '/admin/adminUser/index', '/admin/adminAccess/index', '/admin/frontRole/index', '/admin/frontUser/index' ] },
      //   children: [
      //     {
      //       path: '/privileges/management',
      //       name: 'management',
      //       component: RouteView,
      //       meta: { title: '管理组', keepAlive: true, permission: [ '/admin/adminRole/index', '/admin/adminUser/index', '/admin/adminAccess/index' ] },
      //       children: [
      //         {
      //           path: '/privileges/management-group',
      //           name: 'ManagementGroup',
      //           component: () => import('@/views/privileges/management/ManagementGroup'),
      //           meta: { title: '角色管理', keepAlive: true, permission: [ '/admin/adminRole/index' ] }
      //         },
      //         // {
      //         //   path: '/privileges/administrators',
      //         //   name: 'Administrators',
      //         //   component: () => import('@/views/privileges/management/administrators'),
      //         //   meta: { title: '管理员', keepAlive: true, permission: [ '/admin/adminUser/index' ] }
      //         // },
      //         {
      //           path: '/privileges/menulist',
      //           name: 'Menulist',
      //           component: () => import('@/views/privileges/management/MenuList'),
      //           meta: { title: '菜单列表', keepAlive: true, permission: [ '/admin/adminAccess/index' ] }
      //         }
      //       ]
      //     },
      //     {
      //       path: '/privileges/user',
      //       name: 'User',
      //       component: RouteView,
      //       meta: { title: '用户组', keepAlive: true, permission: [ '/admin/frontRole/index', '/admin/department/index', '/admin/frontUser/index' ] },
      //       children: [
      //         // {
      //         //   path: '/privileges/usergroup/user-group',
      //         //   name: 'UserGroup',
      //         //   component: () => import('@/views/privileges/usergroup/user-group'),
      //         //   meta: { title: '角色管理', keepAlive: true, permission: [ '/admin/frontRole/index' ] }
      //         // },
      //         // {
      //         //   path: '/privileges/usergroup/user-framework',
      //         //   name: 'UserFramework',
      //         //   component: () => import('@/views/privileges/usergroup/user-framework'),
      //         //   meta: { title: '组织架构', keepAlive: true, permission: [ '/admin/department/index' ] }
      //         // },
      //         {
      //           path: '/privileges/usergroup/user-list',
      //           name: 'UserList',
      //           component: () => import('@/views/privileges/usergroup/user-list'),
      //           meta: { title: '用户列表', keepAlive: true, permission: [ '/admin/frontUser/index' ] }
      //         }
      //       ]
      //     }
      //   ]
      // }
      // forms
      // {
      //   path: '/form',
      //   redirect: '/form/base-form',
      //   component: PageView,
      //   meta: { title: '表单页', icon: 'form', permission: [ 'form' ] },
      //   children: [
      //     {
      //       path: '/form/base-form',
      //       name: 'BaseForm',
      //       component: () => import('@/views/form/BasicForm'),
      //       meta: { title: '基础表单', keepAlive: true, permission: [ 'form' ] }
      //     },
      //     {
      //       path: '/form/step-form',
      //       name: 'StepForm',
      //       component: () => import('@/views/form/stepForm/StepForm'),
      //       meta: { title: '分步表单', keepAlive: true, permission: [ 'form' ] }
      //     },
      //     {
      //       path: '/form/advanced-form',
      //       name: 'AdvanceForm',
      //       component: () => import('@/views/form/advancedForm/AdvancedForm'),
      //       meta: { title: '高级表单', keepAlive: true, permission: [ 'form' ] }
      //     }
      //   ]
      // },
      //
      // // list
      // {
      //   path: '/list',
      //   name: 'list',
      //   component: PageView,
      //   redirect: '/list/table-list',
      //   meta: { title: '列表页', icon: 'table', permission: [ 'table' ] },
      //   children: [
      //     {
      //       path: '/list/table-list',
      //       name: 'TableListWrapper',
      //       hideChildrenInMenu: true, // 强制显示 MenuItem 而不是 SubMenu
      //       component: () => import('@/views/list/TableList'),
      //       meta: { title: '查询表格', keepAlive: true, permission: [ 'table' ] }
      //     },
      //     {
      //       path: '/list/basic-list',
      //       name: 'BasicList',
      //       component: () => import('@/views/list/StandardList'),
      //       meta: { title: '标准列表', keepAlive: true, permission: [ 'table' ] }
      //     },
      //     {
      //       path: '/list/card',
      //       name: 'CardList',
      //       component: () => import('@/views/list/CardList'),
      //       meta: { title: '卡片列表', keepAlive: true, permission: [ 'table' ] }
      //     },
      //     {
      //       path: '/list/search',
      //       name: 'SearchList',
      //       component: () => import('@/views/list/search/SearchLayout'),
      //       redirect: '/list/search/article',
      //       meta: { title: '搜索列表', keepAlive: true, permission: [ 'table' ] },
      //       children: [
      //         {
      //           path: '/list/search/article',
      //           name: 'SearchArticles',
      //           component: () => import('../views/list/search/Article'),
      //           meta: { title: '搜索列表（文章）', permission: [ 'table' ] }
      //         },
      //         {
      //           path: '/list/search/project',
      //           name: 'SearchProjects',
      //           component: () => import('../views/list/TableList'),
      //           meta: { title: '搜索列表（项目）', permission: [ 'table' ] }
      //         },
      //         {
      //           path: '/list/search/application',
      //           name: 'SearchApplications',
      //           component: () => import('../views/list/TableList'),
      //           meta: { title: '搜索列表（应用）', permission: [ 'table' ] }
      //         }
      //       ]
      //     }
      //   ]
      // },
      //
      // // profile
      // {
      //   path: '/profile',
      //   name: 'profile',
      //   component: RouteView,
      //   redirect: '/profile/basic',
      //   meta: { title: '详情页', icon: 'profile', permission: [ 'profile' ] },
      //   children: [
      //     {
      //       path: '/profile/basic',
      //       name: 'ProfileBasic',
      //       component: () => import('@/views/profile/basic/Index'),
      //       meta: { title: '基础详情页', permission: [ 'profile' ] }
      //     },
      //     {
      //       path: '/profile/advanced',
      //       name: 'ProfileAdvanced',
      //       component: () => import('@/views/profile/advanced/Advanced'),
      //       meta: { title: '高级详情页', permission: [ 'profile' ] }
      //     }
      //   ]
      // },
      //
      // // result
      // {
      //   path: '/result',
      //   name: 'result',
      //   component: PageView,
      //   redirect: '/result/success',
      //   meta: { title: '结果页', icon: 'check-circle-o', permission: [ 'result' ] },
      //   children: [
      //     {
      //       path: '/result/success',
      //       name: 'ResultSuccess',
      //       component: () => import(/* webpackChunkName: "result" */ '@/views/result/Success'),
      //       meta: { title: '成功', keepAlive: false, hiddenHeaderContent: true, permission: [ 'result' ] }
      //     },
      //     {
      //       path: '/result/fail',
      //       name: 'ResultFail',
      //       component: () => import(/* webpackChunkName: "result" */ '@/views/result/Error'),
      //       meta: { title: '失败', keepAlive: false, hiddenHeaderContent: true, permission: [ 'result' ] }
      //     }
      //   ]
      // },
      //
      // // Exception
      // {
      //   path: '/exception',
      //   name: 'exception',
      //   component: RouteView,
      //   redirect: '/exception/403',
      //   meta: { title: '异常页', icon: 'warning', permission: [ 'exception' ] },
      //   children: [
      //     {
      //       path: '/exception/403',
      //       name: 'Exception403',
      //       component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403'),
      //       meta: { title: '403', permission: [ 'exception' ] }
      //     },
      //     {
      //       path: '/exception/404',
      //       name: 'Exception404',
      //       component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404'),
      //       meta: { title: '404', permission: [ 'exception' ] }
      //     },
      //     {
      //       path: '/exception/500',
      //       name: 'Exception500',
      //       component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500'),
      //       meta: { title: '500', permission: [ 'exception' ] }
      //     }
      //   ]
      // },
      //
      // // account
      // {
      //   path: '/account',
      //   component: RouteView,
      //   redirect: '/account/center',
      //   name: 'account',
      //   meta: { title: '个人页', icon: 'user', keepAlive: true, permission: [ 'user' ] },
      //   children: [
      //     {
      //       path: '/account/center',
      //       name: 'center',
      //       component: () => import('@/views/account/center/Index'),
      //       meta: { title: '个人中心', keepAlive: true, permission: [ 'user' ] }
      //     },
      //     {
      //       path: '/account/settings',
      //       name: 'settings',
      //       component: () => import('@/views/account/settings/Index'),
      //       meta: { title: '个人设置', hideHeader: true, permission: [ 'user' ] },
      //       redirect: '/account/settings/base',
      //       hideChildrenInMenu: true,
      //       children: [
      //         {
      //           path: '/account/settings/base',
      //           name: 'BaseSettings',
      //           component: () => import('@/views/account/settings/BaseSetting'),
      //           meta: { title: '基本设置', hidden: true, permission: [ 'user' ] }
      //         },
      //         {
      //           path: '/account/settings/security',
      //           name: 'SecuritySettings',
      //           component: () => import('@/views/account/settings/Security'),
      //           meta: { title: '安全设置', hidden: true, keepAlive: true, permission: [ 'user' ] }
      //         },
      //         {
      //           path: '/account/settings/custom',
      //           name: 'CustomSettings',
      //           component: () => import('@/views/account/settings/Custom'),
      //           meta: { title: '个性化设置', hidden: true, keepAlive: true, permission: [ 'user' ] }
      //         },
      //         {
      //           path: '/account/settings/binding',
      //           name: 'BindingSettings',
      //           component: () => import('@/views/account/settings/Binding'),
      //           meta: { title: '账户绑定', hidden: true, keepAlive: true, permission: [ 'user' ] }
      //         },
      //         {
      //           path: '/account/settings/notification',
      //           name: 'NotificationSettings',
      //           component: () => import('@/views/account/settings/Notification'),
      //           meta: { title: '新消息通知', hidden: true, keepAlive: true, permission: [ 'user' ] }
      //         }
      //       ]
      //     }
      //   ]
      // },
      //
      // // other
      // {
      //   path: '/other',
      //   name: 'otherPage',
      //   component: PageView,
      //   meta: { title: '其他组件', icon: 'slack', permission: [ 'dashboard' ] },
      //   redirect: '/other/icon-selector',
      //   children: [
      //     {
      //       path: '/other/icon-selector',
      //       name: 'TestIconSelect',
      //       component: () => import('@/views/other/IconSelectorView'),
      //       meta: { title: 'IconSelector', icon: 'tool', keepAlive: true, permission: [ 'dashboard' ] }
      //     },
      //     {
      //       path: '/other/list',
      //       component: RouteView,
      //       meta: { title: '业务布局', icon: 'layout', permission: [ 'support' ] },
      //       redirect: '/other/list/tree-list',
      //       children: [
      //         {
      //           path: '/other/list/tree-list',
      //           name: 'TreeList',
      //           component: () => import('@/views/other/TreeList'),
      //           meta: { title: '树目录表格', keepAlive: true }
      //         },
      //         {
      //           path: '/other/list/edit-table',
      //           name: 'EditList',
      //           component: () => import('@/views/other/TableInnerEditList'),
      //           meta: { title: '内联编辑表格', keepAlive: true }
      //         },
      //         {
      //           path: '/other/list/user-list',
      //           name: 'UserList',
      //           component: () => import('@/views/other/UserList'),
      //           meta: { title: '用户列表', keepAlive: true }
      //         },
      //         {
      //           path: '/other/list/role-list',
      //           name: 'RoleList',
      //           component: () => import('@/views/other/RoleList'),
      //           meta: { title: '角色列表', keepAlive: true }
      //         },
      //         {
      //           path: '/other/list/system-role',
      //           name: 'SystemRole',
      //           component: () => import('@/views/role/RoleList'),
      //           meta: { title: '角色列表2', keepAlive: true }
      //         },
      //         {
      //           path: '/other/list/permission-list',
      //           name: 'PermissionList',
      //           component: () => import('@/views/other/PermissionList'),
      //           meta: { title: '权限列表', keepAlive: true }
      //         }
      //       ]
      //     }
      //   ]
      // }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [
      {
        path: 'home',
        name: 'TestHome',
        component: () => import('@/views/Home')
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]
